import { Box, DropdownButton, DropdownMenu, Heading3, QuietButton, TruncatedText } from "@nulogy/components";
import React from "react";
import styled from "styled-components";
import DateTime from "utils/DateTime";
import { calculateDateWidthFromShifts } from "./WidthCalculator";

const Header = styled(Box)(({ width, left, theme }) => ({
  background: "white",
  borderRight: `1px solid ${theme.colors.lightGrey}`,
  marginLeft: `${left}px`,
  maxWidth: `${width}px`,
  minWidth: `${width}px`,
}));

function dateDisplayName(date) {
  return DateTime.format(date, "ddd D");
}

export default function AvailabilityDateHeader({ date, index, shifts, selectAllForDate, deselectAllForDate }) {
  const width = calculateDateWidthFromShifts(index, shifts);
  const left = index === 0 ? 107 : 0;

  return (
    <Header left={left} width={width}>
      <DropdownMenu
        placement="bottom-start"
        trigger={() => (
          <QuietButton style={{ width: "100%" }}>
            <TruncatedText fullWidth>
              <Heading3 color="darkGrey" data-testid="date-header" fontWeight="light" mb={0} whiteSpace="nowrap">
                {dateDisplayName(date)}
              </Heading3>
            </TruncatedText>
          </QuietButton>
        )}
      >
        {({ closeMenu }) => (
          <>
            <DropdownButton
              onClick={(e) => {
                selectAllForDate(date);
                closeMenu(e);
              }}
              type="button"
            >
              Select&nbsp;all
            </DropdownButton>
            <DropdownButton
              onClick={(e) => {
                deselectAllForDate(date);
                closeMenu(e);
              }}
              type="button"
            >
              Deselect&nbsp;all
            </DropdownButton>
          </>
        )}
      </DropdownMenu>
    </Header>
  );
}
